import { render, staticRenderFns } from "./Logger.vue?vue&type=template&id=0dcc0219&"
import script from "./Logger.vue?vue&type=script&lang=js&"
export * from "./Logger.vue?vue&type=script&lang=js&"
import style0 from "./Logger.vue?vue&type=style&index=0&id=0dcc0219&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports